import { ApiError } from 'core/errors/ApiError';
import { humanizeApiError } from 'core/errors/mapFieldErrors';

function readErrorCode(error) {
  return error.code
    || error.data?.code
    || error.payload?.code
    || error.errors?.code?.[0]
    || null;
}

function isExpiredAccessCode(error) {
  const code = String(readErrorCode(error) || '').toLowerCase();
  if (code === 'code_expired' || code === 'expired') {
    return true;
  }
  const message = String(error.message || '').toLowerCase();
  return message.includes('expired') && !message.includes('session');
}

function isSafeLocalizedMessage(message) {
  const text = String(message || '');
  if (!text || text.length > 280) {
    return false;
  }
  return !/stack trace|sqlstate|exception|Illuminate\\|vendor\/laravel|on line \d+|<\s*html/i.test(text);
}

/**
 * Maps Laravel access-code inspect/redeem errors to safe participant messages.
 */
export function mapAccessCodeError(error, t) {
  if (!(error instanceof ApiError)) {
    return t('errors.unexpected');
  }
  if (error.isNetworkError) {
    return t('errors.network');
  }
  if (error.isMalformed || error.status >= 500) {
    return t('errors.server');
  }
  if (error.isUnauthorized()) {
    return t('auth.sessionExpired');
  }
  if (error.isThrottled()) {
    if (error.retryAfterSeconds) {
      return t('errors.throttledWait', { seconds: error.retryAfterSeconds });
    }
    return t('errors.throttled');
  }
  if (error.isConflict()) {
    return t('assessment.companyCode.inProgressConflict');
  }
  if (error.isForbidden()) {
    return t('assessment.companyCode.unavailable');
  }
  if (error.isValidation() || error.status === 404) {
    if (isExpiredAccessCode(error) && isSafeLocalizedMessage(error.message)) {
      return error.message;
    }
    return t('assessment.companyCode.unavailable');
  }
  if (isSafeLocalizedMessage(error.message)) {
    return humanizeApiError(error, t);
  }
  return t('assessment.companyCode.unavailable');
}
